import { render, staticRenderFns } from "./AddMultiplosServicos.vue?vue&type=template&id=54fcf06f&scoped=true"
import script from "./AddMultiplosServicos.vue?vue&type=script&lang=js"
export * from "./AddMultiplosServicos.vue?vue&type=script&lang=js"
import style0 from "./AddMultiplosServicos.vue?vue&type=style&index=0&id=54fcf06f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fcf06f",
  null
  
)

export default component.exports